<div class="bmc-export-header">
    <h3 class="bmc-export-header__text"> {{ 'SYNC_DATA.EXPORT_ENTITY_VALUES' | translate}}</h3>
    <div class="bmc-export-header__close" (click)="closeModal()">
        <svg class="bmc-export-header__close__icon">
            <use href="#icon-close"></use>
        </svg>
    </div>
</div>
<!-- <bs-form-wizard #wizard [steps]="steps" [data]="{syncData: syncData}" [initialStep]="initialStep" (onUpdateData)="setData($event)">
</bs-form-wizard> -->
<app-export-step10 *ngIf="initialStep == 0" [data]="{syncData: syncData}" [exportOnlyUsers]="exportOnlyUsers" (exportFirstTab)="onNext()"></app-export-step10>
<app-export-step30 *ngIf="initialStep == 1" [data]="{syncData: syncData}" [exportOnlyUsers]="exportOnlyUsers" (exportLoading)="exportLoading($event)"></app-export-step30>
<app-export-step40 *ngIf="initialStep == 2" [data]="{syncData: syncData}"></app-export-step40>
<div class="bmc-export-footer">

    <div class="bmc-export-footer__left-container">
        <bzg-button-primary *ngIf="initialStep > 0 && initialStep < steps.length - 1" type="button" class="btnFooterWhite" (click)="onPrevious()">{{ 'SYNC_DATA.BUTTON_PREVIOUS' | translate}}</bzg-button-primary>
    </div>
    <div class="bmc-export-footer__right-container">
        <bzg-button-primary *ngIf="initialStep == 0 && isSelectedSomeEntity()" type="button" (click)="onNext()"
        [disabled]="!(isSelectedSomeUser() || isSelectedSomeEntity())">{{'SYNC_DATA.BUTTON_NEXT' | translate}}</bzg-button-primary>
        <bzg-button-primary *ngIf="initialStep == 1 || (initialStep == 0 && !isSelectedSomeEntity())" type="button" (click)="onExport()"
        [disabled]="(!isSelectedSomeEntityKey() && isSelectedSomeEntity()) || (!isSelectedSomeUser() && !isSelectedSomeEntity())">{{'SYNC_DATA.EXPORT' | translate}}</bzg-button-primary>
        <bzg-button-primary *ngIf="initialStep == 2" type="button" (click)="closeModal()">{{'SYNC_DATA.BUTTON_CLOSE' | translate}}</bzg-button-primary>
    </div>
</div>
